import { Outlet } from 'react-router-dom'
import { DisclaimerBanner } from './DisclaimerBanner'
import { SiteNav } from './SiteNav'
import { SiteFooter } from './SiteFooter'
import { t } from '@/lib/ui'

// The site shell every page inherits (DESIGN-BRIEF §3): a sticky header holding
// the persistent disclaimer banner + nav, the main content region, and the
// footer. Used as the router's layout element; pages render into <Outlet />.
export function PageShell() {
  return (
    <div className="flex min-h-screen flex-col bg-paper">
      <a href="#main" className="skip-link">
        {t('nav.skipToContent')}
      </a>
      <header className="sticky top-0 z-30">
        <DisclaimerBanner />
        <SiteNav />
      </header>
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  )
}
